import { render } from "./Utilization.vue?vue&type=template&id=2d3be480"
import script from "./Utilization.vue?vue&type=script&lang=js"
export * from "./Utilization.vue?vue&type=script&lang=js"

import exportComponent from "/Users/klaus/Projects/sfdc-happy-soup/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__